import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowrightFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.16 18a.63.63 0 0 1-.463-.198.7.7 0 0 1-.197-.521V6.719q0-.324.199-.521A.64.64 0 0 1 10.162 6q.067 0 .46.223l4.575 5.014q.158.173.23.357A1.1 1.1 0 0 1 15.5 12a1.1 1.1 0 0 1-.073.406 1.2 1.2 0 0 1-.23.357l-4.575 5.014a.7.7 0 0 1-.211.163.54.54 0 0 1-.25.06"
  }));
}
var IcArrowrightFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowrightFill));

export { IcArrowrightFill as I };
